import { format } from 'date-fns';

export const formatHour = (date: Date) => {
  return format(date, 'p');
};
